export const FILE_SIZE = 500000

export const SUPPORTED_FORMATS = ['image/png']
